// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3bEbo","col":"CardReaderDesc_col__JyO2m","label":"CardReaderDesc_label__3Hmjg"};